import { String, Static, Object } from '@sinclair/typebox';

export type Association = Static<typeof Association>;
export const Association = Object({
  selectorId: String(),
});
